export const PVGesamtbeitrag = [
  {
    'PAISY Wert': 0,
    Bezeichnung: 'entfällt',
  },
  {
    'PAISY Wert': 1,
    Bezeichnung: 'BBG',
  },
  {
    'PAISY Wert': 3,
    Bezeichnung: 'Entgelt',
  },
];
